import gql from 'graphql-tag';

export const CREATE_KEYWORD = gql`
  mutation createKeyword($name: String!) {
    createKeyword(name: $name) {
      id
      name
    }
  }
`;
